module.exports = __webpack_public_path__ + "static/image_4-9e21a5dc8b7a1581efeef5b7878f8014.jpg";